
import { Component, Mixins } from "vue-property-decorator";
import { IDateCalculateBehavior } from "../../../../../../documaker/domain/format/objects";
import { IDataCalculateBehaviorPropertyEditable, instanceOfIDataCalculateBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class DateCalculateBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDataCalculateBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDataCalculateBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isDateCalculateBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDataCalculateBehaviorPropertyEditable(s) && s.dateCalculateBehavior().isEditable(), false);
  }

  get dateCalculateBehavior(): IDateCalculateBehavior {
    return this.readPropertyOrDefault(s => s.dateCalculateBehavior().getValue(), { items: [] });
  }

  set dateCalculateBehavior(value: IDateCalculateBehavior) {
    this.writePropertyWhenValid(s => s.dateCalculateBehavior().setValue(value));
  }
}
